export default {
  // End.vue
  end_thanks_message: 'Bedankt voor het deelnemen aan dit onderzoek!',

  // Error.vue
  error_title: 'Er is iets verkeerd gegaan',
  error_description: 'Iets ging verkeerd, neem contact met ons op als dit probleem zich blijf voor doen.',

  // Error404.vue
  not_found: 'Pagina niet gevonden',
  not_found_more: '',

  // Home.vue
  home_welcome: 'Welkom bij dit onderzoek',
  home_surveyUuid: 'Vul hier een onderzoeksnummer in',

  // IntroLong.vue
  intro_long_title: 'Introductie lange vragen',
  intro_long_body:
    ' Bij de volgende afbeeldingen mag je {n} seconde kijken voordat je aan mag geven of een afbeelding echt ' +
    'of nep is. |' +
    ' Bij de volgende afbeeldingen mag je {n} seconden kijken voordat je aan mag geven of een afbeelding echt ' +
    'of nep is.',
  btn_long: 'Start met lange vragen',

  // IntroPractise.vue
  intro_practise_title: 'Introductie oefen vragen',
  intro_practise_body:
    'Er worden een aantal afbeeldingen weergegeven, voor iedere afbeelding moet je aangeven of je denkt dat de ' +
    'afbeelding echt of nep is.\n' +
    '\n' +
    'De eerste paar afbeeldingen worden gebruikt om je te laten wennen aan het systeem.',
  btn_practise: 'Start met oefen vragen',

  // IntroShort.vue
  intro_short_title: 'Introductie korte vragen',
  intro_short_body: ' |' +
    ' Bij de volgende afbeeldingen mag je {n} seconde kijken voordat je aan mag geven of een afbeelding echt ' +
    'of nep is. |' +
    ' Bij de volgende afbeeldingen mag je {n} seconden kijken voordat je aan mag geven of een afbeelding echt ' +
    'of nep is.',
  btn_short: 'Start met korte vragen',

  // Submit.vue
  submit_feedback: 'Wanneer zag je direct dat een afbeelding nep was? En waardoor kwam dit?',
  btn_submit: 'Opslaan',

  // Survey.vue
  welcome: 'Welkom bij dit onderzoek',
  welcome_msg: 'Bedankt dat je met dit onderzoek wil helpen, vul je naam en leeftijd in om door te gaan.',
  welcome_msg_more: 'Met dit onderzoek willen we uitzoeken hoe makkelijk of hoe moelijk het is om oppervlakkig neppe' +
    ' afbeeldingen te maken. Opervlakkig neppe afbeeldingen zijn afbeeldingen die er in eerste instantie echt uit' +
    ' zien, maar als je er langer naar kijkt zie je dat de afbeelding nep is. In dit onderzoek worden afbeeldingen' +
    ' weergegeven, eerst met een korte tijdslimiet en daarna met een langere tijdslimiet. Voor iedere afbeelding' +
    ' wordt gevraagd of deze echt of nep is.',
  name: 'Naam',
  age: 'Leeftijd',
  start: 'Start onderzoek',

  // Question.vue
  make_a_choice: 'Maak een keuze',
  real: 'Echt',
  fake: 'Nep',

  // general
  back: 'Terug',
  submit: 'Opslaan',
  offline: 'De service is offline, het is niet mogelijk om onderzoeken op te slaan.',
};

